import { request } from './client';
import type { ThreadAccountResponse } from './types';

export function getAllThreadAccounts() {
  return request<ThreadAccountResponse[]>('/api/thread-accounts/all', {
    method: 'GET',
  });
}

export function getAccountById(id: number) {
  return request<ThreadAccountResponse>(`/api/thread-accounts/id/${id}`, {
    method: 'GET',
  });
}

export function deleteThreadAccount(id: number) {
  return request<string>(`/api/thread-accounts/id/${id}`, {
    method: 'DELETE',
  });
}

/**
 * Threads 계정 연동을 시작합니다.
 * 같은 탭에서 이동해야 Meta → 백엔드 콜백 → 프론트 /account 리다이렉트가 정상 동작합니다.
 */
export async function openOAuthLoginForNewAccount() {
  const { authorizationUrl } = await request<{ authorizationUrl: string }>(
    '/api/thread-accounts/oauth/connect',
    { method: 'POST', credentials: 'include' }
  );
  window.location.assign(authorizationUrl);
}
